import { SeatRow, workItemUrl } from './work-queue.utils';

export interface ReportedWorkCard {
  key: string;
  seat: SeatRow;
  title: string;
  reference: string | null;
  kind: string;
  source: 'current' | 'owed';
  blocking: boolean;
  ticketUrl: string | null;
}

/** Project the current wire contract without treating an idle seat as work.
 * Owed references are not necessarily tickets; only explicit WI references
 * can use the existing ADO link resolver. PR and Halo links need source data. */
export function buildReportedWorkCards(rows: SeatRow[]): ReportedWorkCard[] {
  return rows.flatMap((seat) => {
    const cards: ReportedWorkCard[] = [];
    if (
      seat.currentTicketId ||
      seat.currentTicketTitle ||
      seat.currentActivity ||
      seat.active
    ) {
      cards.push({
        key: JSON.stringify([seat.instanceId, 'current']),
        seat,
        title:
          seat.currentTicketTitle ||
          seat.currentActivity ||
          seat.currentTicketId ||
          'Active work details not reported',
        reference: seat.currentTicketId,
        kind: 'Current work claim',
        source: 'current',
        blocking: false,
        ticketUrl: seat.ticketUrl,
      });
    }
    for (const [index, item] of seat.owedItems.entries()) {
      cards.push({
        key: JSON.stringify([
          seat.instanceId,
          'owed',
          index,
          item.type,
          item.ref,
        ]),
        seat,
        title: item.label || item.ref || 'Obligation details not reported',
        reference: item.ref || null,
        kind: item.type || 'Obligation',
        source: 'owed',
        blocking: item.blocking,
        ticketUrl: /^(?:WI|Bug|Task|Feature|Story|US)\s*#?\d{4,6}\b/i.test(
          item.ref
        )
          ? workItemUrl(item.ref)
          : null,
      });
    }
    return cards;
  });
}
